<div *ngIf="buildingId$ | async as id; else noId"></div>
<ng-template #noId>There was no building selected</ng-template>
